import { render } from "../templates/variable-grid.html?vue&type=template&id=501397a0"
import script from "./variable-grid.vue?vue&type=script&lang=js"
export * from "./variable-grid.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__